import Analytics from 'analytics'
import kelvinPlugin from './analytics_kelvin_plugin'
import { isIframed } from '../helpers/iframe'

let analyticsInstance = null

export async function kelvinAnalytics () {
  if (analyticsInstance) {
    return analyticsInstance
  }

  analyticsInstance = Analytics({
    app: 'kelvin',
    plugins: [kelvinPlugin()]
  })

  return analyticsInstance
}

export function getAnalyticsConfig () {
  return document.getElementById('analytics-config')
}

export function analyticsDisabled () {
  return getAnalyticsConfig()?.getAttribute('data-disable-analytics') === 'true'
}

export function respectingConsent (cb) {
  const config = getAnalyticsConfig()
  if (!config) {
    cb()
    return
  }

  const consentNeeded = config.getAttribute('data-analytics-consent-needed-value') === 'true'
  const consentGiven = config.getAttribute('data-analytics-consent-given-value') === 'true'

  if (!consentNeeded || consentGiven) {
    cb()
  }
}

export function pageProperties () {
  const pagePropertiesMeta = document.querySelector('meta[name="analytics-page-properties"]')?.getAttribute('content')
  const parsedPageProperties = pagePropertiesMeta ? JSON.parse(pagePropertiesMeta) : {}

  return {
    ...parsedPageProperties,
    ...globalPageProperties()
  }
}

function globalPageProperties () {
  return {
    iframed: isIframed(),
    device_type: detectDeviceType()
  }
}

function detectDeviceType () {
  const width = window.innerWidth
  if (width < 768) return 'mobile'
  if (width < 1024) return 'tablet'
  return 'desktop'
}
